import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import styles from './styles.css';

export default function ChipList({ placeholder, onChange, validator, errorMessage, values }) {
  const [chipList, setChipList] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const [displayError, setDisplayError] = React.useState(false);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const validateInput = () => {
    if (inputValue.length) {
      if (validator) {
        if (validator(inputValue)) {
          addChip();
          if (displayError) {
            hideError();
          }
        } else {
          showError();
        }
      } else {
        addChip();
      }
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === 'Enter') {
      validateInput();
    }
  };

  const showError = () => setDisplayError(true);

  const hideError = () => setDisplayError(false);

  const addChip = () => {
    const newChipList = [...chipList, inputValue];
    setChipList(newChipList);
    setInputValue('');
    onChange(newChipList);
  };

  const removeChip = (word, e) => {
    const newChipList = chipList.filter(w => w !== word);
    setChipList(newChipList);
    onChange(newChipList);
    e.preventDefault();
  };

  React.useEffect(() => {
    setChipList(values);
  }, [values]);

  return (
    <>
      <div className={styles.chipsContainer}>
        {chipList.length ? chipList.map(word => (
          <div className={styles.chip} key={word}>
            <span>{word}</span>
            <button
              type="button"
              className={styles.removeChip}
              onClick={e => removeChip(word, e)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        )) : null}
        <input
          className={styles.chipListInput}
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleOnKeyDown}
          onBlur={validateInput}
        />
      </div>
      {displayError && <span className={styles.errorMessage}>{errorMessage}</span>}
    </>
  );
}

ChipList.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  validator: PropTypes.func,
  errorMessage: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
};

ChipList.defaultProps = {
  placeholder: 'Add keywords',
  onChange: () => { },
  validator: null,
  errorMessage: 'Not a valid value',
  values: [],
};
